import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//角色列表
export const rolelist= params=> {return addinstance().get(geturl(`/role/index`),{params:params});}
// //管理员删除
// export const deleteadmin= params => {return instance.post(geturl(`/api/admin/delete`), params) };
// //管理员基础信息修改
// export const updateadmin= params => { 
//     if(params.password){
//         params.password=md5(params.password)
//     }
//     return instance.post(geturl(`/admin/update`), params) };
// //添加管理员
// export const createadmin= params => {
//     if(params.password){
//         params.password=md5(params.password)
//     } 
//     return instance.post(geturl(`/admin/create`), params) };
// //管理员详情
// export const admindetail= params=> {return instance.get(geturl(`/admin/detail`),{params:params});}
// //锁定
// export const lockadmin= params => { return instance.post(geturl(`/admin/lock`), params) };
// //检查管理员的用户名是否可用
export const rolename= params => { return addinstance().post(geturl(`/role/name`), params) };
export const addrole = params => { return addinstance().post(geturl(`/role/create`),params)};
export const roleupdate = params => { return addinstance().post(geturl(`/role/update`),params)};
export const roledelete = params => { return addinstance().post(geturl(`/role/delete`),params)};








// WEBPACK FOOTER //
// ./src/api/roleapi.js